import React, { useState, useEffect } from 'react';
import { getUserById, encryptPassword, editUser, createUser } from '../service/authService';
import { getAllRoles } from '../service/roleService';
import SelectBox from '../common/SelectBox';
import Input from '../common/Input';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getVendorAccounts } from '../service/vendorService';

const initUser = {
   username: '',
   password: '',
   confirm: '',
   email: '',
   roles: [],
   accounts: [],
};

export default function User(props) {
   // const [user, setUser] = useState(initUser);
   const formik = useFormik({
      initialValues: { ...initUser },
      validationSchema: validation,
      onSubmit: (values, setSubmitting) => {
         if (edit) {
            handleEditUser(values);
         } else {
            handleCreateUser(values);
         }
         setSubmitting(false);
      },
   });
   const [roles, setRoles] = useState([]);
   const [edit, setEdit] = useState(false);
   const [accounts, setAccounts] = useState([]);
   const { userId } = props.match.params;

   const fetchRoles = () => {
      getAllRoles()
         .then((response) => {
            const foundRoles = response.data.data;
            setRoles(foundRoles);
         })
         .catch((error) => {
            toast.error('Could not fetch roles', { autoClose: 2000 });
         });
   };

   const fetchUserById = () => {
      if (userId) {
         getUserById(userId)
            .then((response) => {
               let foundUser = response.data.data;
               formik.setValues(foundUser);
               console.dir(foundUser);
               setEdit(true);
            })
            .catch((error) => {
               toast.error('An error occurs !!!');
               console.dir(error);
            });
      } else {
         setEdit(false);
      }
   };

   const onCancel = (e) => {
      e.preventDefault();
      props.history.push('/UserList');
   };

   const handleCreateUser = (values) => {
      let requestData = { ...values };
      requestData.password = encryptPassword(values.password);
      requestData.confirm = encryptPassword(values.confirm);
      if (!values.accounts) {
         requestData.accounts = [];
      }
      createUser(requestData)
         .then((response) => {
            const newUser = response.data.data;
            let newUsername = newUser.username;
            toast.info(`User ${newUsername} has been created successfully`, { autoClose: 2000 });
            props.history.push('/UserList');
         })
         .catch((error) => {
            toast.error("An error occurs !! Can't edit user", { autoClose: 2000 });
            console.dir(error);
         });
   };

   const handleEditUser = (values) => {
      let requestData = { ...values };
      if (!values.accounts) {
         requestData.accounts = [];
      }
      console.log(requestData);
      editUser(requestData)
         .then((response) => {
            const editedUser = response.data.data;
            let editedUsername = editedUser.username;
            toast.info(`User ${editedUsername} has been edited successfully`, { autoClose: 2000 });
            props.history.push('/UserList');
         })
         .catch((error) => {
            toast.error("An error occurs !! Can't edit user", { autoClose: 2000 });
            console.dir(error);
         });
   };

   useEffect(fetchUserById, []);

   useEffect(fetchRoles, []);

   useEffect(() => {
      const fetchVendorAccounts = async () => {
         try {
            const result = await getVendorAccounts();
            const vendors = result.data.data;
            setAccounts(vendors);
         } catch (error) {
            console.dir(error);
         }
      };
      fetchVendorAccounts();
   }, []);

   return (
      <div className='container'>
         <div className='row'>
            <div className='col-md-6 offset-md-3'>
               <form className='form' onSubmit={formik.handleSubmit}>
                  <h5 className='text-muted'>{edit ? 'Edit User' : 'New User'}</h5>
                  <hr />
                  <div className='form-group'>
                     <label>Username</label>
                     <Input
                        type='text'
                        className='form-control form-control-sm custom-input'
                        name='username'
                        id='username'
                        value={formik.values.username}
                        onChange={formik.handleChange}
                     />
                     {formik.errors.username && formik.touched.username && <div className='invalid-feedback'>{formik.errors.username}</div>}
                  </div>
                  <div className='form-group'>
                     <label>Email</label>
                     <Input
                        type='text'
                        className='form-control form-control-sm custom-input'
                        name='email'
                        id='email'
                        value={formik.values.email}
                        onChange={formik.handleChange}
                     />
                     {formik.errors.email && formik.touched.email && <div className='invalid-feedback'>{formik.errors.email}</div>}
                  </div>
                  {!edit && (
                     <div className='form-row'>
                        <div className='form-group col-md-6'>
                           <label>Password</label>
                           <Input
                              type='password'
                              className='form-control form-control-sm custom-input'
                              name='password'
                              id='password'
                              value={formik.values.password}
                              onChange={formik.handleChange}
                           />
                           {formik.errors.password && formik.touched.password && <div className='invalid-feedback'>{formik.errors.password}</div>}
                        </div>
                        <div className='form-group col-md-6'>
                           <label htmlFor='confirm'>Confirm Password</label>
                           <Input
                              type='password'
                              className='form-control form-control-sm custom-input'
                              name='confirm'
                              id='confirm'
                              value={formik.values.confirm}
                              onChange={formik.handleChange}
                           />
                           {formik.errors.confirm && formik.touched.confirm && <div className='invalid-feedback'>{formik.errors.confirm}</div>}
                        </div>
                     </div>
                  )}

                  <div className='form-group'>
                     <div className='form-group'>Roles</div>
                     <SelectBox
                        name='roles'
                        id='roles'
                        getOptionLabel={({ roleName }) => roleName}
                        getOptionValue={({ roleId }) => roleId}
                        value={formik.values.roles}
                        options={roles}
                        isMulti
                        onChange={(selected) => formik.setFieldValue('roles', selected)}
                        onBlur={(selected) => formik.setFieldTouched('roles', selected)}
                     />
                     {formik.errors.roles && formik.touched.roles && <div className='invalid-feedback'>{formik.errors.roles}</div>}
                  </div>
                  <div className='form-group'>
                     <div className='form-group'>Associated Account</div>
                     <SelectBox
                        name='accounts'
                        id='accounts'
                        getOptionLabel={({ vendorAccountName }) => vendorAccountName}
                        getOptionValue={({ vendorAccountId }) => vendorAccountId}
                        value={formik.values.accounts}
                        options={accounts}
                        isMulti
                        onChange={(selected) => formik.setFieldValue('accounts', selected)}
                        onBlur={(selected) => formik.setFieldTouched('accounts', selected)}
                     />
                     {formik.errors.accounts && formik.touched.accounts && <div className='invalid-feedback'>{formik.errors.accounts}</div>}
                  </div>
                  <div className='form-group'>
                     <button type='submit' className='btn btn-sm btn-primary btn-custom-blue mr-2' disabled={formik.isSubmitting}>
                        {edit ? 'Change User' : 'Create User'}
                     </button>
                     <button className='btn btn-sm btn-outline-info' onClick={onCancel}>
                        Cancel
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </div>
   );
}

const validation = Yup.object({
   username: Yup.string().min(5, 'Username is too short').max(64, 'Username is too long.max 64 characters').required('Username is required'),
   email: Yup.string().email('Invalid email ').required('Email is required '),
   password: Yup.string().min(5, 'Password is too short').max(64, 'Password is too long.max 64 characters').required('Password is required'),
   confirm: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Password must match')
      .required('Confirm password is required'),
   roles: Yup.array().min(1, 'User role should be at least one'),
   accounts: Yup.array().nullable(),
});
